import { template } from "@ember/template-compiler";
import { action } from '@ember/object';
import { modifier } from 'ember-modifier';
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import Component from '@glimmer/component';
import SpdsCheckbox from 'ember-simplepractice/components/spds/input/checkbox';
export default class RequestClinicianSearchFiltersFilterCheckboxLine extends Component {
    get checkboxId() {
        let kind1 = String(this.args.kind ?? '').trim();
        let optionId1 = String(this.args.optionId ?? '').trim();
        return `clinician-search-filter-${kind1}-${optionId1}`;
    }
    get disabledHintId() {
        let kind1 = String(this.args.kind ?? '').trim();
        let optionId1 = String(this.args.optionId ?? '').trim();
        if (!kind1 || optionId1 === '' || !this.args.disabled || !this.args.title) {
            return null;
        }
        return `clinician-search-filter-${kind1}-${optionId1}-disabled-hint`;
    }
    setupInputA11y = modifier((element1)=>{
        let input1 = element1.querySelector('input');
        if (!input1) {
            return;
        }
        if (this.disabledHintId) {
            input1.setAttribute('aria-describedby', this.disabledHintId);
        } else {
            input1.removeAttribute('aria-describedby');
        }
        let ariaLabel1 = String(this.args.ariaLabel ?? '').trim();
        if (ariaLabel1) {
            input1.setAttribute('aria-label', ariaLabel1);
        } else {
            input1.removeAttribute('aria-label');
        }
    });
    @action
    handleClick({ event: event1 }) {
        this.args.onChange?.(event1);
    }
    static{
        template(`
    <li
      class="filter-checkbox-line"
      data-test-clinician-search-filter-option-doc-count={{@docCount}}
    >
      <SpdsCheckbox
        class="filter-checkbox-row"
        @id={{this.checkboxId}}
        @checked={{@checked}}
        @disabled={{@disabled}}
        @onClick={{this.handleClick}}
        {{this.setupInputA11y}}
      >
        <:label>
          <span class="filter-checkbox-text">
            <span class="filter-option-text-content">{{yield}}</span>
            {{#if this.disabledHintId}}
              <span id={{this.disabledHintId}} class="visually-hidden">{{@title}}</span>
            {{/if}}
            {{#if @title}}
              <AttachTooltip
                @placement="right"
                @class="tooltip align-left filter-disabled-tooltip-popover"
              >
                {{@title}}
              </AttachTooltip>
            {{/if}}
          </span>
        </:label>
      </SpdsCheckbox>
    </li>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
